<!-- 印章 -->
<template>
  <div class="myseatpage">
    <div class="header-infor">
      <div class="classroom">
        {{ dataInfor.classroom ? dataInfor.classroom.classroomText : "" }}
      </div>
      <div class="myseat">
        我的座位:
        {{
          selfData.seatRow
            ? "第" + selfData.seatRow + "排第" + selfData.seatColumn + "列"
            : "暂未排座"
        }}
      </div>
    </div>
    <div class="pageContent">
      <div class="seatcontent">
        <div class="restroom"><div class="text">讲台</div></div>
        <div class="seats">
          <div class="seats_content">
            <div
              class="row"
              v-for="(row, rowindex) in arrangeData"
              :key="rowindex"
            >
              <div
                class="column"
                :id="column.self ? 'self' : ''"
                v-for="(column, colindex) in row"
                :key="colindex"
              >
                <img
                  v-if="column && column.self == true"
                  :src="
                    require('_teas/public/img/product/myseat/icon-zw-grenn.png')
                  "
                  class="img"
                  alt=""
                  srcset=""
                />
                <img
                  v-else-if="column && column.self == false"
                  :src="
                    require('_teas/public/img/product/myseat/icon-zw-blue.png')
                  "
                  class="img"
                  alt=""
                  srcset=""
                />
                <img
                  v-else
                  :src="
                    require('_teas/public/img/product/myseat/icon-zw-gray.png')
                  "
                  class="img"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="footeritem">
            <img
              :src="
                require('_teas/public/img/product/myseat/icon-zw-grenn.png')
              "
              class="img"
              alt=""
              srcset=""
            />
            <div>我的</div>
          </div>
          <div class="footeritem">
            <img
              :src="require('_teas/public/img/product/myseat/icon-zw-blue.png')"
              class="img"
              alt=""
              srcset=""
            />
            <div>有人</div>
          </div>
          <div class="footeritem">
            <img
              :src="require('_teas/public/img/product/myseat/icon-zw-gray.png')"
              class="img"
              alt=""
              srcset=""
            />
            <div>无人</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasMySeat",
  ctrlCaption: "学员我的座位",
  mixins: [$mixins.control],
  design: {},
  props: {
    url: {
      type: String,
      default: "teas/classes/seat/mySeatTable",
    },
  },
  data() {
    return {
      dataInfor: {},
      arrangeData: [],
      selfData: {},
    };
  },
  created() {
    if (this.isDesign) {
      this.dataInfor = {};
    } else {
      //获取信息
      this.getInfor();
    }
  },
  mounted() {},
  methods: {
    // 获取信息
    getInfor() {
      var loading = dsf.layer.loading();
      this.$http
        .get("teas/classes/seat/mySeatTable")
        .done((res) => {
          console.log(res);
          if (res.success && res.state == 20000) {
            this.dataInfor = res.data;
            this.arrangeConfig();
          } else {
            this.$message(res.message, false);
          }
        })
        .error((err) => {
          this.$message("请求失败", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    arrangeConfig() {
      this.arrangeData = [];
      for (var row = 0; row < this.dataInfor.classroom.classroomRow; row++) {
        var tempArray = [];
        for (
          var column = 0;
          column < this.dataInfor.classroom.classroomColumn;
          column++
        ) {
          tempArray.push({});
        }
        this.arrangeData.push(tempArray);
      }
      this.dataInfor.seats.forEach((item) => {
        if (item.self) {
          this.selfData = item;
        }
        var tempRow = parseInt(item.seatRow) - 1;
        var tempColumn = parseInt(item.seatColumn) - 1;
        this.arrangeData[tempRow][tempColumn] = item;
      });
      if (this.selfData.seatRow) {
        this.$nextTick(() => {
          document.querySelector("#self").scrollIntoView(false);
        });
      }
      console.log(this.arrangeData);
    },
  },
});
</script>
